var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFileuseFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.3835,
    height: 20,
    rx: 2,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.5V5.5H8.5V8.5V9H8H5V14.5H12V13.5H13V14.5V15.5H12H5H4V14.5V7.5L7 4.5H8.5H12H13V5.5V7.5H12ZM7.41421 5.5H7.5V8H5V7.91421L7.41421 5.5Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.522 8.75521L12.2239 10.0533L10.9258 8.75521L10.8198 8.64915L10.7137 8.75521L10.3627 9.10625L10.2566 9.21232L10.3627 9.31839L11.6608 10.6165L10.4107 11.8666L10.3046 11.9727L10.4107 12.0787L10.7617 12.4298L10.8678 12.5358L10.9738 12.4298L12.2239 11.1797L13.522 12.4778L13.6281 12.5838L13.7342 12.4778L14.0852 12.1267L14.1913 12.0207L14.0852 11.9146L12.7871 10.6165L14.0852 9.31839L14.1913 9.21232L14.0852 9.10625L13.7342 8.75521L13.6281 8.64915L13.522 8.75521Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8833 11.7929L19.5904 9.5H24.1762L21.8833 11.7929Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileuseFalse);
export default __webpack_public_path__ + "static/media/ico-fileuse-false.7d58277e42d9fd1d637c167b8fe17a75.svg";
export { ForwardRef as ReactComponent };